import React, { useState } from 'react';
import './SafetyProtocol.css';

const SafetyProtocol = ({ isVisible, onClose, onProceed, protocolType = 'hv' }) => {
  const [checklist, setChecklist] = useState({
    step1: false,
    step2: false,
    step3: false,
    step4: false,
    ppe1: false,
    ppe2: false,
    ppe3: false
  });

  const allChecked = Object.values(checklist).every(v => v);

  const handleCheckChange = (key) => {
    setChecklist(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleProceed = () => {
    if (allChecked) {
      onProceed();
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="safety-protocol-overlay fade-in">
      <div className="safety-protocol-modal pulse-border">
        {/* Header */}
        <div className="safety-header">
          <div className="safety-icon-large">⚡</div>
          <h2>High-voltage safety protocol</h2>
          <p className="safety-subtitle">Mandatory procedures. Do not skip any step.</p>
        </div>

        {/* Warning Banner */}
        <div className="critical-warning pulse-warning">
          <span className="warning-icon">⚠️</span>
          <div>
            <strong>DANGER: HIGH VOLTAGE</strong>
            <p>350V DC system - Potentially fatal electric shock risk</p>
            <p>Only certified EV technicians may proceed</p>
          </div>
        </div>

        {/* Safety Steps Checklist */}
        <div className="safety-content">
          <h3>Mandatory Safety Steps</h3>
          <div className="checklist">
            <label className={`checklist-item ${checklist.step1 ? 'checked' : ''}`}>
              <input
                type="checkbox"
                checked={checklist.step1}
                onChange={() => handleCheckChange('step1')}
              />
              <span className="checkmark"></span>
              <div className="check-content">
                <strong>Step 1:</strong> Turn OFF ignition and remove key from vehicle
              </div>
            </label>

            <label className={`checklist-item ${checklist.step2 ? 'checked' : ''}`}>
              <input
                type="checkbox"
                checked={checklist.step2}
                onChange={() => handleCheckChange('step2')}
              />
              <span className="checkmark"></span>
              <div className="check-content">
                <strong>Step 2:</strong> Disconnect 12V auxiliary battery (negative terminal first)
              </div>
            </label>

            <label className={`checklist-item ${checklist.step3 ? 'checked' : ''}`}>
              <input
                type="checkbox"
                checked={checklist.step3}
                onChange={() => handleCheckChange('step3')}
              />
              <span className="checkmark"></span>
              <div className="check-content">
                <strong>Step 3:</strong> Remove HV service plug (orange connector)
              </div>
            </label>

            <label className={`checklist-item ${checklist.step4 ? 'checked' : ''}`}>
              <input
                type="checkbox"
                checked={checklist.step4}
                onChange={() => handleCheckChange('step4')}
              />
              <span className="checkmark"></span>
              <div className="check-content">
                <strong>Step 4:</strong> Wait 10 minutes for capacitor discharge
              </div>
            </label>
          </div>

          <h3>Required Personal Protective Equipment</h3>
          <div className="checklist">
            <label className={`checklist-item ${checklist.ppe1 ? 'checked' : ''}`}>
              <input
                type="checkbox"
                checked={checklist.ppe1}
                onChange={() => handleCheckChange('ppe1')}
              />
              <span className="checkmark"></span>
              <div className="check-content">
                <strong>PPE 1:</strong> Class 0 HV insulating gloves (1000V rated) + leather protectors
              </div>
            </label>

            <label className={`checklist-item ${checklist.ppe2 ? 'checked' : ''}`}>
              <input
                type="checkbox"
                checked={checklist.ppe2}
                onChange={() => handleCheckChange('ppe2')}
              />
              <span className="checkmark"></span>
              <div className="check-content">
                <strong>PPE 2:</strong> Safety glasses with side shields
              </div>
            </label>

            <label className={`checklist-item ${checklist.ppe3 ? 'checked' : ''}`}>
              <input
                type="checkbox"
                checked={checklist.ppe3}
                onChange={() => handleCheckChange('ppe3')}
              />
              <span className="checkmark"></span>
              <div className="check-content">
                <strong>PPE 3:</strong> Insulated tools (minimum 1000V rating)
              </div>
            </label>
          </div>

          {/* Emergency Contact */}
          <div className="emergency-info">
            <h4>🚨 Emergency Contact</h4>
            <p>In case of electric shock: <strong>Call Emergency Services Immediately</strong></p>
            <p>EV Safety Hotline: <strong>1-800-EV-SAFETY</strong></p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="safety-actions">
          <button className="cancel-btn" onClick={onClose}>
            Cancel Operation
          </button>
          <button
            className={`proceed-btn ${allChecked ? 'enabled' : 'disabled'}`}
            onClick={handleProceed}
            disabled={!allChecked}
          >
            {allChecked ? '✓ Safety Protocol Complete - Proceed' : '⚠ Complete All Steps to Proceed'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SafetyProtocol;
